import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Button from '@mui/material/Button';
import Grid2 from '@mui/material/Grid2';
import Paper from '@mui/material/Paper';
import Tab from '@mui/material/Tab';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { TableCellProps } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelectedTournament } from '../../contexts/SelectedTournamentContext';
import { Tournament } from '../../models/Tournament';
import { getTournamentResult, GroupTable } from '../../services/TournamentService';
import { getImageUrl } from '../../utils/Url';

const StyledTableCell: React.FC<TableCellProps> = ({ children, sx, ...props }) => {
  return (
    <TableCell sx={{ padding: 0.75, ...sx }} {...props}>
      {children}
    </TableCell>
  );
};

export const Result = () => {
  const { tournamentId } = useParams<{ tournamentId: string }>();
  const { setSelectedTournament } = useSelectedTournament();
  const navigate = useNavigate();
  const [tournament, setTournament] = useState<Tournament>();
  const [selectedPhaseId, setSelectedPhaseId] = useState<string>();
  const [groupTables, setGroupTables] = useState<GroupTable[]>([]);

  useEffect(() => {
    if (tournamentId) {
      getTournamentResult(tournamentId).then((result) => {
        setTournament(result._tournament);
        setGroupTables(result.groupTables);
        setSelectedPhaseId(result._tournament.phases[0].id.toString());
        setSelectedTournament(result._tournament);
      });
    }
  }, []);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setSelectedPhaseId(newValue);
  };

  const getLogo = (name: string, logoUrl: string) => {
    return (
      <img width={'40'} height={'40'} style={{ paddingRight: '.75em' }} src={getImageUrl(logoUrl)} alt={'Logo zespołu ' + name} />
    );
  };

  const handleTeamSchedule = (teamId: number) => {
    navigate(`/tournament/${tournamentId}/phase/${selectedPhaseId}/team/${teamId}/schedule`);
  };

  return (
    <>
      {tournament && tournament.phases.length > 0 && selectedPhaseId !== undefined && (
        <TabContext value={selectedPhaseId}>
          <TabList onChange={handleChange} aria-label="Fazy" variant="fullWidth">
            {tournament.phases.map((phase) => (
              <Tab key={'tab' + phase.id} label={phase.name} value={phase.id.toString()} />
            ))}
          </TabList>
          {tournament.phases.map((phase) => (
            <TabPanel key={'tabPanel' + phase.id} value={phase.id.toString()} sx={{ padding: 1 }}>
              <Grid2 container spacing={3} justifyContent={'center'}>
                {phase.groups.map((group) => (
                  <Grid2 size={{ xs: 12, md: 9 }} key={group.id} justifyContent={'center'}>
                    <TableContainer component={Paper} elevation={2}>
                      <Table padding="none">
                        <TableHead>
                          <TableRow>
                            <TableCell align="center" colSpan={7} sx={{ padding: 0.75 }} className="row-separator">
                              <Typography variant="h6">{group.name}</Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <StyledTableCell>Lp.</StyledTableCell>
                            <StyledTableCell width="50%">Nazwa</StyledTableCell>
                            <StyledTableCell>Pkt.</StyledTableCell>
                            <StyledTableCell>M</StyledTableCell>
                            <StyledTableCell>Z</StyledTableCell>
                            <StyledTableCell>S</StyledTableCell>
                            <StyledTableCell>B</StyledTableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {groupTables
                            .find((gt) => gt.groupId === group.id)
                            ?.groupTableRows.map((gtr) => (
                              <TableRow key={'' + group.id + gtr.teamId}>
                                <StyledTableCell>
                                  <Typography>{gtr.teamRanking}</Typography>
                                </StyledTableCell>
                                <StyledTableCell>
                                  <Button onClick={() => handleTeamSchedule(gtr.teamId)}>
                                    <div
                                      style={{
                                        display: 'flex',
                                        wordBreak: 'break-word',
                                        alignItems: 'center',
                                        color: 'rgba(0, 0, 0, 0.87)',
                                      }}
                                    >
                                      {gtr.teamName && gtr.teamLogo && getLogo(gtr.teamName, gtr.teamLogo)}
                                      {gtr.teamName ?? '-'}
                                    </div>
                                  </Button>
                                </StyledTableCell>
                                <StyledTableCell>{gtr.teamPoints}</StyledTableCell>
                                <StyledTableCell>{gtr.matchesCount}</StyledTableCell>
                                <StyledTableCell>{gtr.teamWinGoals}</StyledTableCell>
                                <StyledTableCell>{gtr.teamLossGoals}</StyledTableCell>
                                <StyledTableCell>{gtr.teamGoalsBalance}</StyledTableCell>
                              </TableRow>
                            ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid2>
                ))}
              </Grid2>
            </TabPanel>
          ))}
        </TabContext>
      )}
    </>
  );
};
